<pbc-filter [config]="FeldKategoriesFilterConfig" [filter]="feldKategories.filter$ | async" (filterChange)="feldKategories.filter$.next($event)"></pbc-filter>
